import { Flex, Tooltip, Typography } from 'antd'
import { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { useStyles } from './styles'

type Props = {
  logo: ReactNode
  title: ReactNode
  isCollapsed: boolean
}

/**
 *
 * @param logo - The logo of the application
 * @param title - The title of the application
 * @param isCollapsed - The state of the sidebar
 * @description This component is the header of the application.
 * @example
 * ```tsx
 * <Header logo={logo} title={title} isCollapsed={isCollapsed} />
 * ```
 */

export const Header = ({ isCollapsed, logo, title }: Props) => {
  const { styles } = useStyles()

  const logoSrc =
    typeof logo === 'string' ? <img src={logo} alt="collapsed icon" /> : logo

  return (
    <Flex align="center">
      <Flex
        className={isCollapsed ? styles.collapsedLogo : styles.logo}
        style={{ width: isCollapsed ? '49px' : '235px' }}
      >
        <Link to="/">
          <Tooltip title={title} placement="right">
            <Flex gap={8} align="center" className={styles.text}>
              {logoSrc}
              <div
                className={isCollapsed ? styles.collapseTitle : styles.title}
              >
                <Typography.Title level={5}>{title}</Typography.Title>
              </div>
            </Flex>
          </Tooltip>
        </Link>
      </Flex>
    </Flex>
  )
}
